.nav-main ul {
  list-style: none;
  padding-top: 0;
}

.nav-main ul li {
  color: var(--white);
}

.nav-main .nav-separator {
  opacity: 50%;
  margin: 1rem;
  background-color: var(--white-50);
  height: 1px;
}

.nav-main ul li a {
  display: block;
  position: relative;
  margin-block: 15px;
  background-color: var(--deep-blue);
  width: 100%;
  height: 30px;
  color: var(--white);
  font-size: 1.6rem;
  line-height: 30px;
  text-align: center;
}

.nav-main li a span {
  display: none;
  position: absolute;
  top: 0;
  left: 120%;
  opacity: 0;
  transition: opacity 300ms linear;
  width: max-content;
  pointer-events: none;
}

.nav-main li.active a i,
.nav-main li a:hover i {
  font-weight: 400;
}

.nav-main li a:hover span {
  opacity: 1;
}

@media only screen and (min-width: 992px) {
  .nav-main ul li a {
    margin-block: 10px;
  }

  .nav-main li a span {
    display: block;
  }
}
